<template>
  <div>
    <div class="columns">
      <div class="column">
        <h3 class="title is-size-5">{{ $t('modules.positions.index.sendReportModal.emailFormTitle') }}</h3>
        <!-- <p>
          {{ $t('modules.positions.index.sendReportModal.emailFormNotice') }}
        </p> -->

        <InputMaterialWrap
          v-model="sendTo.contact1"
          :label="$t('modules.positions.index.sendReportModal.emailFormTo1')"
          validate="required|email"
          input-id="emailContact1"
          @input="updateFormData"
        />

        <InputMaterialWrap
          v-model="sendTo.contact2"
          :label="$t('modules.positions.index.sendReportModal.emailFormTo2')"
          validate="email"
          input-id="emailContact2"
          @input="updateFormData"
        />

        <InputMaterialWrap
          v-model="sendTo.contact3"
          :label="$t('modules.positions.index.sendReportModal.emailFormTo3')"
          validate="email"
          input-id="emailContact3"
          @input="updateFormData"
        />
      </div>
      <div class="column message_inputs_column">

        <InputMaterialWrap
          v-model="message.subject"
          :label="$t('modules.positions.index.sendReportModal.emailFormSubject')"
          input-id="contactEmailSubject"
          @input="updateFormData"
        />

        <TextareaMaterialWrap
          v-model="message.content"
          :label="$t('modules.positions.index.sendReportModal.emailFormContent')"
          input-id="contactEmailContent"
          @input="updateFormData"
          />

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SendReportEmailForm",
  components: {},
  data() {
    return {
      sendTo: {
        contact1: "",
        contact2: "",
        contact3: ""
      },
      message: {
        subject: this.$t("modules.positions.index.sendReportModal.emailFormSubjectPlaceholder"),
        content: ""
      }
    };
  },
  mounted() {
    this.message.content = this.getEmailPlaceholder();
  },
  computed: {
    currentPosition() {
      return this.$store.state.PositionStore.currentPosition;
    }
  },
  methods: {
    checkEmails() {
      this.$validator.validateAll();
      return (
        this.fields.emailContact1.valid &&
        this.fields.emailContact2.valid &&
        this.fields.emailContact3.valid
      );
    },
    updateFormData() {
      if (this.checkEmails()) {
        this.$emit("dataValid", this.sendTo, this.message);
      } else {
        this.$emit("dataInvalid");
      }
    },
    getEmailPlaceholder() {
      if (this.currentPosition) {
        return (
          this.$t('modules.positions.index.sendReportModal.emailFormContentPlaceholder', {name: JSON.parse(localStorage.getItem("user")).username, positionName: this.currentPosition.name})
        );
      }
    }
  }
};
</script>

<style lang="scss" >
.message_inputs_column {
  border-left: 1px solid $grey-lighter;
  .input,
  textarea,
  .notification {
    border-radius: 6px;
  }
  textarea {
    // min-height: 230px !important;
    // max-height: 800px !important;
  }
}
</style>